import { of } from 'rxjs';
import { booleanOptions, eqOperator } from '../../filtre-investisseur-helper';
import { FiltreBuilder, ItemFiltreCustomBuilder } from '../filtre-builder.model';

export function getReglementaireBuilders(): FiltreBuilder[] {
  return [
    new ItemFiltreCustomBuilder(
      'REGLEMENTAIRE',
      'REGLEMENTAIRE_EXPOSE_POLITIQUEMENT',
      'atlasInvestisseur.investisseurPersonnePhysiques.some.personnePhysique.reglementaire.ppeStatut',
      eqOperator,
      'Select',
      of(booleanOptions)
    ),
  ];
}
